export default "__VITE_ASSET__BqkM2Igw__"